import _ from 'lodash'
import L1Title from '../l1/L1Title'
import { L2Column, L2ColumnLayout } from '../l2/L2ColumnLayout'
import { Concept } from '@fusion-advantage/formlib'

interface L3TitleProps {
	tier: number
	title?: string
	concept?: Concept
	print: boolean,
	required?: boolean,
}

const L3Title = ({tier, title, concept, print, required = false}: L3TitleProps) => {
	const component = <L1Title tier={tier} print={print} title={title ?? concept?.title ?? ''} required={required} />
	if(tier === 1 && print) {
		return (
			<L2ColumnLayout columnCount={1}>
				<L2Column>
					{component}
				</L2Column>
			</L2ColumnLayout>
		)
	}
	return component
}

export default L3Title
